/**
 * @generated SignedSource<<3205d98ae8beae3dcda3953d3813cfb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateRelatedTemplatesRelayFragment$data = {
  readonly relatedTemplates: ReadonlyArray<{
    readonly templateId: string;
    readonly " $fragmentSpreads": FragmentRefs<"templateCardRelayFragment">;
  }> | null | undefined;
  readonly " $fragmentType": "templateRelatedTemplatesRelayFragment";
};
export type templateRelatedTemplatesRelayFragment$key = {
  readonly " $data"?: templateRelatedTemplatesRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateRelatedTemplatesRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateRelatedTemplatesRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplate",
      "kind": "LinkedField",
      "name": "relatedTemplates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "templateCardRelayFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "826c8adfd1c7809b66dd0577af98a2dc";

export default node;
